<div class="empty-state" [class]="'empty-state--' + size">
    <div class="empty-state__icon">
        <mat-icon>{{ icon }}</mat-icon>
    </div>
    <h3 class="empty-state__title">{{ title }}</h3>
    <p class="empty-state__message">{{ message }}</p>
    <button *ngIf="showAction && actionLabel" mat-raised-button color="primary" class="empty-state__action"
        (click)="onActionClick()">
        <mat-icon *ngIf="actionIcon">{{ actionIcon }}</mat-icon>
        {{ actionLabel }}
    </button>
</div>